/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadBcrFilesMutationRequest, AuditSupportBulkUploadBcrFilesMutationResponse, AuditSupportBulkUploadBcrFiles401, AuditSupportBulkUploadBcrFiles403 } from "../models/AuditSupportBulkUploadBcrFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditSupportBulkUploadBcrFiles } from "../axios/auditSupportBulkUploadBcrFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditSupportBulkUploadBcrFilesMutationKey = () => [{ url: '/audit-support/v1/bcr-files/bulk-upload' }] as const

export type AuditSupportBulkUploadBcrFilesMutationKey = ReturnType<typeof auditSupportBulkUploadBcrFilesMutationKey>

export function auditSupportBulkUploadBcrFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditSupportBulkUploadBcrFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditSupportBulkUploadBcrFilesMutationKey()
        return mutationOptions<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, {data: AuditSupportBulkUploadBcrFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return auditSupportBulkUploadBcrFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload BCR files
 * {@link /audit-support/v1/bcr-files/bulk-upload}
 */
export function useAuditSupportBulkUploadBcrFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, {data: AuditSupportBulkUploadBcrFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditSupportBulkUploadBcrFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditSupportBulkUploadBcrFilesMutationKey()

          const baseOptions = auditSupportBulkUploadBcrFilesMutationOptions(config) as UseMutationOptions<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, {data: AuditSupportBulkUploadBcrFilesMutationRequest}, TContext>
          

          return useMutation<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, {data: AuditSupportBulkUploadBcrFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, {data: AuditSupportBulkUploadBcrFilesMutationRequest}, TContext>
      
}